import graphql from "babel-plugin-relay/macro";

export const QUERY = graphql`
	query moduleRatingDetailsChart_Query($nodeRef: ID!, $first: Int, $after: String) {
		Admin {
			ModuleRating {
				ModuleRatingCalculations(first: $first, after: $after, nodeRef: $nodeRef) {
					edges {
						node {
							scoreMap {
								zero
								one
								two
								three
								four
								five
							}
						}
					}
				}
			}
		}
	}
`;
